<template>
  <v-app-bar dense app
    color="primary"
    dark
  >
    <div class="d-flex align-center app-title">
      <!-- <v-app-bar-nav-icon @click.stop="sharedState.drawer = !sharedState.drawer"></v-app-bar-nav-icon> -->
      <v-img @click="returnHome" :src="require('@/assets/images/logo.svg')" width="198" class="ml-5"></v-img>
    </div>

    <v-breadcrumbs
        v-if="$route.name === 'MapView'"
      :items="sharedState.breadcrumbs.mapview"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-breadcrumbs
        v-if="$route.name === 'Report'"
      :items="sharedState.breadcrumbs.report"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <v-btn class="mr-4" v-if="sharedState.email" depressed light @click="manual">
      <v-icon left>mdi-file</v-icon>
      <span>マニュアル</span>
    </v-btn>
    <v-menu v-if="sharedState.email" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">
          <v-icon left>mdi-account</v-icon>
          <span>{{ sharedState.email.split("@")[0] }}</span>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item to="/profile/edit" v-if="!sharedState.googleAPI">
          <v-list-item-icon class="mr-2">
            <v-icon left>mdi-account-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <span>プロファイル編集</span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/changepass" v-if="!sharedState.googleAPI">
          <v-list-item-icon class="mr-2">
            <v-icon left>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <span>パスワード変更</span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-icon class="mr-2">
            <v-icon left>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <span>ログアウト</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { store } from "@/store";

export default {
  name: "AppBar",
  data() {
    return {
      sharedState: store.state,
      env: process.env.VUE_APP_ENV,
      dialogChangePassword: false,
      inputChangePass: {
        new_password1: null,
        new_password2: null,
        old_password: null,
      },
      editPassFormValid: true,
    };
  },
  methods: {
    logout() {
      const token = this.sharedState.token;
      this.axios
        .post("/api/dj-rest-auth/logout/", { access_token: token })
        .then(() => {
          this.setLogoutStatus();
          this.$router.push("/login");
        })
        .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
        });
    },
    setLogoutStatus() {
      store.updateLogoutStatus();
      this.axios.defaults.headers.common["Authorization"] = "";
    },
    returnHome() {
      this.$router.push('/').catch(err => { return err });
    },
    manual() {
      const link = 'https://docs.google.com/document/d/1cpuMnRMjgQ06KuQ7x5tsTuba_L9VZm8U/edit';
      window.open(link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar .theme--dark.v-select .v-select__selection--comma,
.v-app-bar .theme--dark.v-input.v-select,
.v-app-bar .v-select .theme--dark.v-icon {
  color: #333;
}
.v-app-bar .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 36px;
}
.v-app-bar .v-select.v-input {
  max-width: 170px;
}
.v-app-bar .v-toolbar__content {
  padding-left: 0px;
}
.v-text-field .v-select__selections > input {
  width: 0px;
}
.v-app-bar .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding: 0px 10px;
}
.v-app-bar .v-text-field.v-text-field--solo .v-input__control input {
  display: none;
}
.v-app-bar .v-select.v-input--dense .v-select__selection--comma {
  margin-right: 0px;
}
.v-application--is-ltr .v-app-bar .v-text-field .v-input__append-inner {
  padding-left: 0px;
}
.v-app-bar .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #fff;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #fff;
}
.switch-left {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.switch-right {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
